export const publishedFiles = [
  { title: "Resume", href: "/ShyamSS-resume.pdf", type: "PDF" },
  { title: "AI Landscape", href: "/ai", type: "HTML" },
  { title: "AI Roadmap", href: "/ai-roadmap", type: "HTML" },
  {
    title: "AI Mastery Knowledge Base",
    href: "/ai_mastery_knowledge_base",
    type: "HTML",
  },
  { title: "Notes", href: "/notes", type: "HTML" },
  { title: "Prep-Arch Pitch", href: "/prep-arch-pitch", type: "HTML" },
  {
    title: "Vox OS App Demo",
    href: "/voxos",
    type: "HTML",
  },
  {
    title: "Vox OS Info",
    href: "/voxos_info",
    type: "HTML",
  },
  {
    title: "Vox OS Docs",
    href: "/voxos-docs",
    type: "HTML",
  },
  { title: "NM Archstudio 01", href: "/nm.archstudio_01", type: "HTML" },
  { title: "NM Archstudio 02", href: "/nm.archstudio_02", type: "HTML" },
  { title: "NM Archstudio 03", href: "/nm.archstudio_03", type: "HTML" },
  {
    title: "Voice App Dev Board",
    href: "/voice_app_dev_board",
    type: "HTML",
  },
  {
    title: "Voice App Flutter Tech Stack",
    href: "/voice_app_flutter_techstack",
    type: "HTML",
  },
  {
    title: "Voice App Architecture",
    href: "/voice_app_architecture.pdf",
    type: "PDF",
  },
  {
    title: "RAG Systems Complete Notes",
    href: "/RAG_Systems_Complete_Notes.pdf",
    type: "PDF",
  },
  {
    title: "Software Idea Pre-Check Checklist",
    href: "/software_idea_checklist",
    type: "HTML",
  },
];
